export default __webpack_public_path__ + "static/media/planet5.5ea6909b.webp";